import { styled } from 'styled-components';

import { cssBreakpoints, spacing } from '#/theme/theme';

const LABELS_HEIGHT_PER_LINE = 20;
const LABELS_LINE_GAP = 8;

export const SearchVolopHitLabels = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${spacing[LABELS_LINE_GAP]};
  margin: 15px 0 10px;

  @media all and (max-width: ${cssBreakpoints.lgDown}) {
    overflow: hidden;
    max-height: ${LABELS_HEIGHT_PER_LINE * 2 + LABELS_LINE_GAP}px;
  }

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    overflow: hidden;
    max-height: ${LABELS_HEIGHT_PER_LINE}px;
  }
`;
